module.exports = __webpack_public_path__ + "img/card-ap-year.c29bc292.jpg";